import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, ButtonGroup, Row } from "react-bootstrap";

const ScriptsActionCell = props => (
  <Row style={{ display: "block" }}>
    <div className="floatRight">
      <ButtonGroup size="sm">
        <Button
          className="btn-red"
          onClick={event => {
            event.stopPropagation();
            props.onDelete();
          }}
        >
          <FontAwesomeIcon icon={faTrash} size="1x" />
        </Button>
      </ButtonGroup>
    </div>
  </Row>
);


export default ScriptsActionCell;
